const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Slack settings component
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {CompanyIntegrations} CompanyIntegrations injected to gain access to the Company Integrations
 */
app.directive('slackSettings', ['Application', 'CompanyIntegrations', 'SlackIntegrate', function (Application, CompanyIntegrations, SlackIntegrate) {
  return {
    restrict: "E",
    replace: true,
    scope : {
      'modalactive': '=?'
    },
    template: require('../../templates/directives/slack-settings.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var domain = Application.navigation.getHost();
      self.slackLink = Application.slackLink;

      self.toggleModalActive = function(){
        console.log('toggling active modal var');
        $scope.modalactive = !$scope.modalactive;
      };

      self.checkParams = function() {
        var params = Application.navigation.getUrlParameters();
        if (params.code) {
          SlackIntegrate.create({}, {
            code: params.code,
            state: params.state,
            redirect_uri: 'https://' + domain + '/slack'
          }, function(data) {
            self.hasSlack = true;
            self.slackNeedsUpdate = false;

            Application.messaging.addMessage({type: 'success', text: 'Slack Configured!', druation: 5});
            // Application.navigation.goTo('/overview/settings', {});
          }, function(err) {
            console.log('error in making slack integration: ', err)
            Application.navigation.goTo('/overview/settings/integrations', {});
          });
        }

      };

      self.uninstall = function() {
        self.uninstalling = true;

        SlackIntegrate.uninstall({}).$promise
        .then(function(results) {
          if (results.status === 'ok') {
            self.hasSlack = false;
            self.slackNeedsUpdate = false;
          }
          self.uninstalling = false;
          self.showUninstall = false;
        }).catch(function(error) {
          console.log('error: ', error);
          self.uninstalling = false;
        });
      };
      
      self.initialize = function () {
        CompanyIntegrations.status({}, function (data) {
          self.companyIntegration = data || {};
          self.hasSlack = self.companyIntegration.slack;
          self.slackNeedsUpdate = self.companyIntegration.slackNeedsUpdate;

          self.checkParams();
        }, function (error) {
          console.log('Error occured getting company integration ', error);
        });

      };
      self.initialize();
    }],
    controllerAs: 'slack'
  }
}]);
